import {styled} from '@mui/material';
import {clsx} from 'clsx';
import {forwardRef, HTMLAttributes, MouseEventHandler} from 'react';
import {Button, ButtonProps} from '../Button';
import {Typography} from '../Typography';
import {excludeComponentProps} from '../utils/excludeComponentProps';
import {navCssClassNames} from './navCssClassNames';
import {navItemButtonCss} from './navItemButtonCss';

type PickedButtonProps = Pick<ButtonProps, 'component' | 'href' | 'onClick' | 'startIcon' | 'endIcon' | 'children'>;

export interface NavItemButtonProps extends Partial<PickedButtonProps>, HTMLAttributes<unknown> {
    /**
     * Select state.
     * @default false
     */
    selected?: boolean;
    /**
     * Navigation label. Can show up as a button text or as a sub-navigation menu header
     * @default '';
     */
    label?: string;
    /**
      * On Click Handler
      */
    onClick?: MouseEventHandler<unknown>;
    /**
     * Button orientation. Use 'top' if used within the top navigation, or
     * side if used in the a side navigation or fixedSide navigation variant.
     * @default 'top'
     */
    orientation?: 'side' | 'top';
    /**
     * Adds padding to nested elements
     * @default 0
     */
    level?: number;
}

const StyledButton = styled(Button,
    excludeComponentProps('subNavigationItems', 'FlyoutContent', 'orientation', 'size', 'level', 'label', 'hasDivider')
)<NavItemButtonProps>(navItemButtonCss);

export const NavItemButton = forwardRef<unknown, NavItemButtonProps>(({
    className, orientation = 'top', ...props
}, ref) => {
    return (
        <StyledButton
            {...props}
            className={clsx(navCssClassNames.itemButton, className)}
            orientation={orientation}
            ref={ref}
        >
            <Typography
                className={navCssClassNames.itemButtonText}
                noWrap
                variant='button'
            >
                {props.children}
            </Typography>
        </StyledButton>
    );
});

NavItemButton.displayName = 'NavItemButton';
